import UserImg from "../../../../assets/images/avatar.svg";
// import CameraIcon from "../_icons/CameraIcon";

export default function UploadProfileImage({ img }: { img?: string }) {
  return (
    <div className="w-24 h-24 relative select-none">
      <img
        className="w-full h-fuw-full rounded-full"
        src={img || UserImg}
        alt=""
      />
      {/* <div className="w-[22px] h-[22px] right-0 top-[72px] absolute bg-[#f2f6fa] rounded-full border border-white inline-flex justify-center items-center text-body-text cursor-pointer">
        <CameraIcon />
      </div> */}
    </div>
  );
}
